import { createApp } from "vue";
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.min.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { VueReCaptcha } from "vue-recaptcha-v3";

library.add(faInstagram, faGithub);
createApp(App)
  .component("font-awesome-icon", FontAwesomeIcon)
  .use(VueReCaptcha, { siteKey: "6LcmpTQsAAAAAKuw2KuM970SQKkOcmSmMpW8vhcd" })
  .mount("#app");
